{
  "appName": "Submit an intent to file online",
  "entryFile": "./app-entry.jsx",
  "entryName": "21-0966-intent-to-file-a-claim",
  "rootUrl": "/forms/21-0966/submit-intent-to-file",
  "productId": "8233bd78-20c6-4498-b36f-55ec0028b1e5"
}
